import {Inject, Injectable} from '@angular/core';
import {PageState} from '../enums/page-state.enum';
import {BehaviorSubject, Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class PageStateService {
  public readonly state: Observable<PageState>;
  private readonly _state = new BehaviorSubject<PageState>(PageState.Default);

  public constructor(
    private readonly translateService: TranslateService,
    @Inject(Window) private readonly window: Window
  ) {
    this.state = this._state.asObservable();
    this.window.addEventListener('beforeunload', (event) => this.beforeUnloadHandler(event));
  }

  public setState(state: PageState): void {
    this._state.next(state);
  }

  public resetState(): void {
    this._state.next(PageState.Default);
  }

  private beforeUnloadHandler(event: BeforeUnloadEvent): void {
    const currentState = this._state.getValue();
    const statesToAlert = [
      PageState.WaitingForMeta,
      PageState.WaitingForApi
    ];

    if (statesToAlert.includes(currentState)) {
      const message = this.translateService.instant('onboarding-is-not-yet-done');
      this.window.alert(message);
      event.preventDefault();
      // Modern browsers require setting returnValue.
      // They also mostly ignore the custom message, but it's good practice.
      event.returnValue = message;
      return;
    }
  }
}
